import type { AdminCompany } from '../types';

export const filterAdminCompanies = (companies: AdminCompany[], query: string): AdminCompany[] => {
  const q = query.trim().toLowerCase();
  if (!q) return companies;

  return companies.filter(
    (company) =>
      company.name.toLowerCase().includes(q) ||
      (company.full_name ?? '').toLowerCase().includes(q)
  );
};

export const formatAdminCompanyDate = (
  iso: string | null | undefined,
  locale: string
): string => {
  if (!iso) return '-';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleDateString(locale === 'ru' ? 'ru-RU' : 'en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
